import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import buildLinkObj from '@repo/ui/src/functions/build-link';
import Box from '@mui/material/Box';

const GridItem = ({ item }) => {
  const { recipeMetaSection, _meta, assets } = item || {};
  const { deliveryKey } = _meta || {};
  const imgUrl =
    assets?.length > 0 ? buildImageSrc(assets[0], 400, 4, 3) : buildImageSrc(null, 400, 4, 3);
  const linkObj = buildLinkObj({ link: deliveryKey });

  return (
    <Box bgcolor="white" height="100%" p={{ xs: 2, sm: 4 }}>
      <Box component="a" href={linkObj.href} display="flex" flexDirection="column" height="100%">
        <LazyLoadImage
          imgComponent={<img src={imgUrl} alt={recipeMetaSection?.title} width="100%" />}
        />
        <h6 className="tra-text-web-heading-6 tw-mt-3 tw-text-left">{recipeMetaSection?.title}</h6>
      </Box>
    </Box>
  );
};

export default GridItem;
